export default __webpack_public_path__ + "static/media/genom-plusv2-hero@2x.1814507d.png";